module.exports = __webpack_public_path__ + "static/media/newbg1.c18fb951.jpg";